import { makeStyles } from '@surveycake/rc';

const marginTop = 20;

export const useStyles = makeStyles([
  [
    'subjects',
    (theme, [singleSubjectPerPage, breadcrumbCount]) => [
      !singleSubjectPerPage &&
        `
			margin-top: ${marginTop}px;
		`,
      singleSubjectPerPage &&
        `
			display: flex;
			flex-direction: column;
			justify-content: center;
			height: calc(100% - ${30 * breadcrumbCount}px);
		`
    ]
  ]
]);
